import { PharmaAddressDetails } from "@/redux/slice/location/interfaces/PharmaAddressDetails";
import checkTatAvailabilityApi from "@/redux/slice/cart/apis/checkTatAvailabilityApi";
import {
  addUpdateCartItem,
  appendOutOfStockSkus,
  markSkuListInStock,
  setIsCartUpdated,
  setServerCartErrorMessage,
  setUserActionPayload,
} from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { createCartItemFromProduct } from "./createCartItemFromProduct";

interface AddCartItemPayload {
  itemToAdd: CartItem;
  pharmaAddressDetails: PharmaAddressDetails;
  currentPatientId: string;
  dispatch: any;
}

export const addCartItem = ({ itemToAdd, pharmaAddressDetails, currentPatientId, dispatch }: AddCartItemPayload) => {
  if (currentPatientId) {
    dispatch(
      setUserActionPayload({
        medicineOrderCartLineItems: [
          {
            medicineSKU: itemToAdd.sku,
            quantity: itemToAdd.quantity,
          },
        ],
      })
    );
  } else if (pharmaAddressDetails?.pincode) {
    checkTatAvailabilityApi(
      [{ sku: itemToAdd?.sku, qty: itemToAdd.quantity ? itemToAdd.quantity : 1 }],
      pharmaAddressDetails?.pincode,
      pharmaAddressDetails?.lat,
      pharmaAddressDetails?.lng,
      pharmaAddressDetails?.tatInput
    )
      .then((data: any) => {
        if (data?.response?.[0]?.items?.[0]?.exist) {
          dispatch(markSkuListInStock([itemToAdd?.sku]));
          dispatch(addUpdateCartItem(createCartItemFromProduct(itemToAdd)));
          dispatch(setIsCartUpdated(true));
        } else {
          dispatch(appendOutOfStockSkus([itemToAdd?.sku]));
        }
      })
      .catch((e) => {
        dispatch(appendOutOfStockSkus([itemToAdd?.sku]));
        dispatch(setServerCartErrorMessage("Product is Out of Stock"));
        console.error(e, "Product is Not Available to add");
      });
  } else {
    dispatch(addUpdateCartItem(itemToAdd));
    dispatch(setIsCartUpdated(true));
  }
};
